import React, { useEffect, useRef } from "react";
import "./style.css"
import { useState } from "react";
import Loading from "../loadingScreen/Loading";



const FppThreeDSPayment = () => {

    const [showLoader, setShowLoader] = useState(true)

    const generateBrowserDataPayload = () => {
        let userBrowserJavaEnabled

        try {
            userBrowserJavaEnabled = String(window.navigator.javaEnabled());
        } catch (e) {
            userBrowserJavaEnabled = String(false);
        }

        return {
            browserJavaEnabled: userBrowserJavaEnabled,
            browserJavascriptEnabled: String(true),
            browserLanguage: window.navigator.language || window.navigator.userLanguage,
            browserColorDepth: String(window.screen.colorDepth),
            browserScreenHeight: String(window.screen.height),
            browserScreenWidth: String(window.screen.width),
            browserTimeZone: String(new Date().getTimezoneOffset()),
            deviceChannel: 'Browser'
        }
    }


    const paymentResponseHandler = (responseData) => {
        const params = new URLSearchParams(window.location.search);
        const BP_CON = params.get("bpCon");
        const responsePayload = responseData
        const challengeData = responsePayload
        const encodedPayload = btoa(JSON.stringify(challengeData));
        const baseUrl = process.env.REACT_APP_BASE_URL;
        const finalUrl = `${baseUrl}/callbacks/psps/fpp/redirect-response-handler/3ds?bpCon=${BP_CON}&challengeData=${encodedPayload}`
        window.location.replace(finalUrl)
    }

    useEffect(() => {
        const loadScript = (src) =>
            new Promise((resolve, reject) => {
                const script = document.createElement("script");
                script.src = src;
                script.onload = resolve;
                script.onerror = reject;
                document.body.appendChild(script);
            });

        const init3DS = async () => {
            await loadScript("https://secure.fppgateway.com/js/v1/Gateway.js");
            const params = new URLSearchParams(window.location.search);
            const encodedData = params.get("challengeData");
            const decoded = atob(encodedData);

            const parsedData = JSON.parse(decoded);
            const { checkoutPublicKey, cvv, ...restPayload } = parsedData
            const gateway = window.Gateway.create(checkoutPublicKey);

            if (!checkoutPublicKey) {
                const raw = sessionStorage.getItem("s_d");
                const sessionData = JSON.parse(raw);
                if (sessionData) {
                    if (sessionData.callerType == "PAYMENT_LINK") {
                        window.location.replace(`/${sessionData.token}`)
                    } else {
                        window.location.replace(`/?token=${sessionData.token}`)
                    }
                }
            }
            const browserDataPayload = generateBrowserDataPayload()
            const threeDS = gateway.get3DSecure();
            const options = {
                ...restPayload,
                ...browserDataPayload
            };
            const threeDSecureInterface = threeDS.createUI(options);


            threeDSecureInterface.start("#threeDSMountPoint");


            threeDSecureInterface.on("challenge", function () {
                console.log("Challenged");
                setShowLoader(false)
            });

            threeDSecureInterface.on("complete", function (responseData) {
                console.log("3DS complete", responseData);
                setShowLoader(false);
                paymentResponseHandler(responseData)
            });
            threeDSecureInterface.on("failure", function (responseData) {
                setShowLoader(true)
                paymentResponseHandler(responseData)
                console.error("3DS failure", responseData);
            });
            threeDSecureInterface.on("error", function (responseData) {
                setShowLoader(true)
                paymentResponseHandler(responseData)
                console.error("3DS failure", responseData);
            });

            gateway.on("error", function (responseData) {
                paymentResponseHandler(responseData)
                console.error("Gateway error", responseData);
            });
        };

        init3DS();

        return () => {
            try {
                threeDSecureInterface?.destroy?.();
            } catch { }
        };
    }, []);

    return <>
        {showLoader && <Loading
            text="Redirecting you to your bank for verification..."
            subText=""
        />}
        <div id="threeDSMountPoint"></div>
    </>;
};


export default FppThreeDSPayment